import modulesConfig from './modules.config';

export const TECHNIC_PREFIX = {
    ...modulesConfig.TECHNIC_PREFIX
}
